import { Link } from 'react-router-dom';
import './Legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <article className="legal-article">
        <Link to="/" className="legal-back">
          ← Back to home
        </Link>

        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-updated">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })}
        </p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              The Local Jobs New England North West website ("the Site") is operated on behalf of the Department of
              Employment and Workplace Relations (DEWR) as part of the Australian Government&apos;s Local Jobs Program.
              We are committed to protecting your privacy in accordance with the Privacy Act 1988 (Cth) and the
              Australian Privacy Principles.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Information we collect</h2>
            <p>
              We may collect personal information when you: contact us via forms (name, email, message); register for
              the portal; subscribe to updates; or otherwise interact with the Site. We may also collect technical
              information such as your IP address, browser type, and pages visited for security and analytics purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. How we use your information</h2>
            <p>
              We use your information to: respond to enquiries; provide employment and program-related services;
              improve the Site; comply with legal obligations; and communicate with you about the Local Jobs Program
              where you have consented.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Cookies and similar technologies</h2>
            <p>
              The Site may use cookies and similar technologies for essential functionality (e.g. session management),
              analytics, and to remember your preferences. You can manage cookie settings via your browser or our cookie
              controls. For full details, see our <Link to="/cookies">Cookie Policy</Link>.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Disclosure</h2>
            <p>
              We may disclose your information to: DEWR and other Australian Government agencies; service providers who
              assist us (under strict confidentiality); or as required or authorised by law.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Storage and security</h2>
            <p>
              We take reasonable steps to protect your personal information from misuse, loss, and unauthorised access.
              All data is stored in Australia, in accordance with our data sovereignty commitments.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Your rights</h2>
            <p>
              You may request access to, or correction of, your personal information. You may also lodge a complaint
              with the Office of the Australian Information Commissioner (OAIC) if you believe we have breached your
              privacy.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Changes</h2>
            <p>
              We may update this Privacy Policy from time to time. The "Last updated" date at the top of this page
              will reflect any changes. We encourage you to review this policy periodically.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact</h2>
            <p>For privacy enquiries, please contact the Local Jobs New England North West team.</p>
          </section>
        </div>
      </article>
    </div>
  );
}
